







// import React, { useState, useEffect, useRef } from 'react';
// import { BiCheck, BiX } from 'react-icons/bi';
// import Chart from 'chart.js/auto';

// const SuperAdminJobPlans = ({ loggedinUser }) => {
//   const [paymentLogs, setPaymentLogs] = useState([]);
//   const [stats, setStats] = useState({ successful: 0, failed: 0, plans: {} });
//   const paymentChartRef = useRef(null);
//   const planChartRef = useRef(null);
//    const userType= localStorage.getItem('userType');

//   useEffect(() => {
//     const userType= localStorage.getItem('userType');

//     console.log(userType, loggedinUser?.role, "loggedinUser role   ");
//     if (loggedinUser?.role !== 'superadmin' || userType !== 'superadmin' ) return;

//     const fetchPaymentLogs = async () => {
//       try {
//         const response = await fetch(`${process.env.REACT_APP_API_URL}admin/payment-logs`, {
//           headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
//         });
//         const data = await response.json();
//         if (data.status) {
//           const logs = data.data;
//           setPaymentLogs(logs);
//           const successful = logs.filter(log => log.status === 'success').length;
//           const failed = logs.filter(log => log.status === 'failed').length;
//           const plans = logs.reduce((acc, log) => {
//             acc[log.jobType] = (acc[log.jobType] || 0) + 1;
//             return acc;
//           }, {});
//           setStats({ successful, failed, plans });
//         }
//       } catch (error) {
//         console.error('Failed to fetch payment logs:', error);
//       }
//     };
//     fetchPaymentLogs();
//   }, []);

//   useEffect(() => {
//     let paymentChart, planChart;

//     if (paymentChartRef.current) {
//       paymentChart = new Chart(paymentChartRef.current, {
//         type: 'pie',
//         data: {
//           labels: ['Successful', 'Failed'],
//           datasets: [{
//             data: [stats.successful, stats.failed],
//             backgroundColor: ['#4CAF50', '#F44336'],
//           }],
//         },
//         options: { responsive: true, maintainAspectRatio: false },
//       });
//     }

//     if (planChartRef.current) {
//       planChart = new Chart(planChartRef.current, {
//         type: 'pie',
//         data: {
//           labels: ['basic', 'standard', 'premium', 'partner with Ejobs'],
//           datasets: [{
//             data: Object.values(stats.plans).length ? Object.values(stats.plans) : [0, 0, 0, 0],
//             backgroundColor: ['#FF6384', '#36A2EB', '#FFCE56', '#4BC0C0'],
//           }],
//         },
//         options: { responsive: true, maintainAspectRatio: false },
//       });
//     }

//     // Cleanup charts on unmount
//     return () => {
//       if (paymentChart) paymentChart.destroy();
//       if (planChart) planChart.destroy();
//     };
//   }, [stats]);

//   if ( userType !== 'superadmin') {
//     return <div className="text-center py-10 text-gray-600">Access denied. Superadmin role required.</div>;
//   }

//   return (
//     <section className="py-8 px-4 md:px-6 lg:px-8 bg-gray-50 min-h-screen">
//       <div className="max-w-7xl mx-auto">
//         <h1 className="text-2xl md:text-3xl font-bold text-gray-800 mb-6">Superadmin Dashboard</h1>
        
//         <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 mb-8">
//           <div className="p-4 bg-white border border-gray-200 rounded-lg shadow-lg h-64">
//             <h2 className="text-lg font-semibold mb-2">Payment Status</h2>
//             <canvas ref={paymentChartRef} id="paymentChart"></canvas>
//           </div>
//           <div className="p-4 bg-white border border-gray-200 rounded-lg shadow-lg h-64">
//             <h2 className="text-lg font-semibold mb-2">Plan Distribution</h2>
//             <canvas ref={planChartRef} id="planChart"></canvas>
//           </div>
//         </div>

//         <div className="bg-white border border-gray-200 rounded-lg shadow-lg p-4">
//           <h2 className="text-lg font-semibold mb-4">Payment Logs</h2>
//           <div className="overflow-x-auto">
//             <table className="w-full text-sm md:text-base">
//               <thead className="bg-gray-100">
//                 <tr>
//                   <th className="py-2 px-4 text-left">Job Title</th>
//                   <th className="py-2 px-4 text-left">Plan</th>
//                   <th className="py-2 px-4 text-left">Amount (NGN)</th>
//                   <th className="py-2 px-4 text-left">Status</th>
//                   <th className="py-2 px-4 text-left">Applicants</th>
//                   <th className="py-2 px-4 text-left">Date</th>
//                 </tr>
//               </thead>
//               <tbody>
//                 {paymentLogs.map((log) => (
//                   <tr key={log._id} className="border-t">
//                     <td className="py-2 px-4">{log.jobDetails.jobTitle || 'N/A'}</td>
//                     <td className="py-2 px-4">{log.jobType}</td>
//                     <td className="py-2 px-4">{log.amount ? (log.amount / 100) : '0'}</td>
//                     <td className="py-2 px-4">
//                       {log.status === 'success' ? (
//                         <span className="flex items-center text-green-600"><BiCheck className="mr-1" /> Success</span>
//                       ) : (
//                         <span className="flex items-center text-red-600"><BiX className="mr-1" /> Failed</span>
//                       )}
//                     </td>
//                     <td className="py-2 px-4">{log.applicants?.length || '0'}</td>
//                     <td className="py-2 px-4">{new Date(log.timestamp).toLocaleDateString()}</td>
//                   </tr>
//                 ))}
//               </tbody>
//             </table>
//           </div>
//           {paymentLogs.length === 0 && <p className="text-center py-4 text-gray-500">No payment logs available.</p>}
//         </div>
//       </div>
//     </section>
//   );
// };

// export default SuperAdminJobPlans



import React, { useState, useEffect, useRef } from 'react';
import { BiCheck, BiX } from 'react-icons/bi';
import Chart from 'chart.js/auto';

const SuperAdminJobPlans = ({ loggedinUser }) => {
  const [jobs, setJobs] = useState([]);
  const [stats, setStats] = useState({
    successful: 0,
    failed: 0,
    plans: {},
    daily: {},
    weekly: {},
    monthly: {},
    yearly: {},
  });
  const paymentChartRef = useRef(null);
  const planChartRef = useRef(null);
  const userType = localStorage.getItem('userType');
  const apiUrl = process.env.REACT_APP_API_URL || 'http://localhost:3008/api/v1/';

  useEffect(() => {
    if (loggedinUser?.role !== 'superadmin' || userType !== 'superadmin') return;

    const fetchJobs = async () => {
      try {
        const response = await fetch(`${apiUrl}job/allJob`, {
          headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
        });
        const data = await response.json();
        if (data.status) {
          const fetchedJobs = data.data;
          setJobs(fetchedJobs);

          // Aggregate payment stats (assuming jobs include payment-related data)
          const successful = fetchedJobs.filter(job => job.paymentReference).length; // Assuming paymentReference indicates success
          const failed = fetchedJobs.filter(job => !job.paymentReference).length;
          const plans = fetchedJobs.reduce((acc, job) => {
            acc[job.jobType] = (acc[job.jobType] || 0) + 1;
            return acc;
          }, {});
          setStats({ successful, failed, plans, daily: {}, weekly: {}, monthly: {}, yearly: {} }); // Simplified stats for now
        }
      } catch (error) {
        console.error('Failed to fetch jobs:', error);
      }
    };
    fetchJobs();
  }, [loggedinUser, userType]);

  useEffect(() => {
    let paymentChart, planChart;

    if (paymentChartRef.current) {
      paymentChart = new Chart(paymentChartRef.current, {
        type: 'pie',
        data: {
          labels: ['Successful', 'Failed'],
          datasets: [{
            data: [stats.successful, stats.failed],
            backgroundColor: ['#4CAF50', '#F44336'],
          }],
        },
        options: { responsive: true, maintainAspectRatio: false },
      });
    }

    if (planChartRef.current) {
      planChart = new Chart(planChartRef.current, {
        type: 'pie',
        data: {
          labels: ['basic', 'standard', 'premium', 'partner with Ejobs'],
          datasets: [{
            data: Object.values(stats.plans).length ? Object.values(stats.plans) : [0, 0, 0, 0],
            backgroundColor: ['#FF6384', '#36A2EB', '#FFCE56', '#9966FF'],
          }],
        },
        options: { responsive: true, maintainAspectRatio: false },
      });
    }

    return () => {
      if (paymentChart) paymentChart.destroy();
      if (planChart) planChart.destroy();
    };
  }, [stats]);

  const aggregateByInterval = (logs, interval) => {
    return logs.reduce((acc, log) => {
      const date = new Date(log.timestamp);
      let key;
      switch (interval) {
        case 'day': key = date.toLocaleDateString(); break;
        case 'week': key = `${date.getFullYear()}-W${Math.floor(date.getDate() / 7) + 1}`; break;
        case 'month': key = `${date.getFullYear()}-${date.getMonth() + 1}`; break;
        case 'year': key = date.getFullYear().toString(); break;
      }
      acc[key] = (acc[key] || 0) + (log.status === 'success' ? log.amount / 100 : 0);
      return acc;
    }, {});
  };

  if (userType !== 'superadmin') {
    return <div className="text-center py-10 text-gray-600">Access denied. Superadmin role required.</div>;
  }

  return (
    <section className="py-8 px-4 md:px-6 lg:px-8 bg-gray-50 min-h-screen">
      <div className="max-w-7xl mx-auto">
        <h1 className="text-2xl md:text-3xl font-bold text-gray-800 mb-6">Superadmin Dashboard</h1>
        
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 mb-8">
          <div className="p-4 bg-white border border-gray-200 rounded-lg shadow-lg h-64">
            <h2 className="text-lg font-semibold mb-2">Payment Status</h2>
            <canvas ref={paymentChartRef} id="paymentChart"></canvas>
          </div>
          <div className="p-4 bg-white border border-gray-200 rounded-lg shadow-lg h-64">
            <h2 className="text-lg font-semibold mb-2">Plan Distribution</h2>
            <canvas ref={planChartRef} id="planChart"></canvas>
          </div>
        </div>

        <div className="bg-white border border-gray-200 rounded-lg shadow-lg p-4 mb-6">
          <h2 className="text-lg font-semibold mb-4">Payment Aggregates</h2>
          <div className="grid grid-cols-1 md:grid-cols-4 gap-4">
            <div className="p-2 bg-gray-100 rounded">
              <h3 className="font-semibold">Daily Total</h3>
              <p>{Object.values(stats.daily).reduce((a, b) => a + b, 0).toLocaleString()} NGN</p>
            </div>
            <div className="p-2 bg-gray-100 rounded">
              <h3 className="font-semibold">Weekly Total</h3>
              <p>{Object.values(stats.weekly).reduce((a, b) => a + b, 0).toLocaleString()} NGN</p>
            </div>
            <div className="p-2 bg-gray-100 rounded">
              <h3 className="font-semibold">Monthly Total</h3>
              <p>{Object.values(stats.monthly).reduce((a, b) => a + b, 0).toLocaleString()} NGN</p>
            </div>
            <div className="p-2 bg-gray-100 rounded">
              <h3 className="font-semibold">Yearly Total</h3>
              <p>{Object.values(stats.yearly).reduce((a, b) => a + b, 0).toLocaleString()} NGN</p>
            </div>
          </div>
        </div>

        <div className="bg-white border border-gray-200 rounded-lg shadow-lg p-4">
          <h2 className="text-lg font-semibold mb-4">Job Listings</h2>
          <div className="overflow-x-auto">
            <table className="w-full text-sm md:text-base">
              <thead className="bg-gray-100">
                <tr>
                  <th className="py-2 px-4 text-left">Company</th>
                  <th className="py-2 px-4 text-left">Job Title</th>
                  <th className="py-2 px-4 text-left">Plan</th>
                  <th className="py-2 px-4 text-left">Location</th>
                  <th className="py-2 px-4 text-left">Date Posted</th>
                </tr>
              </thead>
              <tbody>
                {jobs.map((job) => (
                  <tr key={job._id} className="border-t">
                    <td className="py-2 px-4">{job.employer?.companyName || 'N/A'}</td>
                    <td className="py-2 px-4">{job.jobTitle}</td>
                    <td className="py-2 px-4">{job.jobType}</td>
                    <td className="py-2 px-4">{`${job.state}, ${job.localGovernment}`}</td>
                    <td className="py-2 px-4">{new Date(job.createdAt).toLocaleDateString()}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
          {jobs.length === 0 && <p className="text-center py-4 text-gray-500">No jobs available.</p>}
        </div>
      </div>
    </section>
  );
};

export default SuperAdminJobPlans;